/*
 * portalTemplateReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 02-Nov-2022
 */

import produce from 'immer';
import { resetReduxState } from 'Utility/globalMethods';
import { actionTypes } from '../actions/portalTemplate';

const ACTION_HANDLERS = {
	[actionTypes.DO_SET_HAS_LOGO]: produce((draft, action) => {
		draft.hasLogo = action.payload;
	}),
	[actionTypes.DO_SET_LIGHT_HEADER]: produce((draft, action) => {
		draft.hasLightBackground = action.payload;
	}),
	[actionTypes.DO_ENABLE_WITH_NAVIGATION]: produce((draft, action) => {
		draft.withNavigation = action.payload;
	}),
	[actionTypes.DO_SHOW_FOOTER]: produce((draft, action) => {
		draft.showFooter = action.payload;
	}),
	[actionTypes.DO_SET_PAGE_TITLE]: produce((draft, action) => {
		draft.pageTitle = action.payload;
	}),
	[actionTypes.DO_SET_GO_BACK_LABEL]: produce((draft, action) => {
		draft.goBackLabel = action.payload;
	}),
	[actionTypes.DO_SET_GO_BACK_ROUTE]: produce((draft, action) => {
		draft.goBackRoute = action.payload;
	}),
	[actionTypes.DO_RESET_STATE]: produce((draft) => {
		resetReduxState(draft, initialState);
	}),
	[actionTypes.DO_SET_CUSTOM_GO_BACK_ON_CLICK]: produce((draft, action) => {
		draft.customGoBackOnClick = action.payload;
	}),
	[actionTypes.DO_SET_LOCK]: produce((draft, action) => {
		draft.isLocked = action.payload;
	}),
	[actionTypes.DO_SET_LOADING]: produce((draft, action) => {
		draft.isLoading = action.payload;
	}),
	// @generator reducer:type:action
};

// The initial state of the portalTemplate
const initialState = {
	withNavigation: true,
	showFooter: true,
	pageTitle: '',
	goBackLabel: '',
	goBackRoute: '',
	customGoBackOnClick: null,
	isLocked: false,
	isLoading: false,
	hasLightBackground: false,
	hasLogo: false,
};

const portalTemplate = (state = initialState, action) => {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
};

export default portalTemplate;
